import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoadingComponent } from '@core/components/loading/loading.component';
import { JWTInterceptor } from '@core/interceptors/jwt.interceptor';
import { TranslateService } from '@core/services/translate.service';
import { SharedModule } from './shared/shared.module';
import { AuthStateService } from '@core/services/auth-state.service';

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    SharedModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: JWTInterceptor, 
      multi: true 
    },
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthStateService) => () => auth.hydrateFromStorage(),
      deps: [AuthStateService],
      multi: true
    },
    TranslateService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
